import React, { FC, ReactNode } from "react";
import { Box, Button, SxProps } from "@mui/material";
import { uiContainerTransitionMs, uiOpacityHover } from "@src/utils";

interface Props {
  url: string;
  bgColor: string;
  textColor: string;
  children: ReactNode;
  sx?: SxProps;
}

export const OutlinedSignup: FC<Props> = ({
  url,
  bgColor,
  textColor,
  children,
  sx,
}) => {
  return (
    <Button
      href={url}
      size="small"
      variant="outlined"
      color="primary"
      disableElevation
      disableRipple
      sx={{
        height: "32px",
        color: textColor,
        border: `1px solid ${textColor}`,
        "&:hover": {
          color: textColor,
          border: `1px solid ${textColor}`,
          opacity: "0.9",
        },
        "&:visited, &:active": {
          color: textColor,
          border: `1px solid ${textColor}`,
        },
        ...sx,
      }}
    >
      {children}
    </Button>
  );
};

export const ContainedSignup: FC<Props> = ({
  url,
  bgColor,
  textColor,
  children,
  sx,
}) => {
  return (
    <Box
      sx={{
        opacity: 1,
        transition: `opacity ${uiContainerTransitionMs}ms ease-in-out`,
        "&:hover": {
          opacity: uiOpacityHover,
        },
      }}
    >
      <Button
        href={url}
        component="a"
        data-testid="topnav-signin-contained"
        size="small"
        variant="contained"
        disableElevation
        disableRipple
        sx={{
          height: "32px",
          fontFamily: "Inter",
          backgroundColor: bgColor,
          color: textColor,
          borderRadius: "64px",
          "&:hover": {
            backgroundColor: bgColor,
            color: textColor,
          },
          "&:visited": {
            color: textColor,
          },
          fontWeight: 600,
          letterSpacing: "-0.25px",
          fontSize: "15px",
          ...sx,
        }}
      >
        {children}
      </Button>
    </Box>
  );
};
